module.exports = __webpack_public_path__ + "media/images/brand/app_symbol-fa8f3a87b748316a6d6a95c5699fb3ce.png";